import { SoundPlayer } from "sound/SoundPlayer";

let soundplayer: SoundPlayer | undefined;

export function getSoundPlayer(): SoundPlayer {

    if (!soundplayer) {
        throw new Error(`SoundPlayer not set yet - getSoundPlayer`);
    }

    return soundplayer;
}

export function setSoundPlayer(soundPlayer: SoundPlayer): void {
    soundplayer = soundPlayer;
}